import { Directive, ElementRef, Input } from '@angular/core';
import { HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Directive({
  selector: '[zcFileHttpDownload]'
})
export class FileHttpDownloadDirective {
  @Input() url: string;
  @Input() payload: any;
  @Input() baseUrl: string;
  @Input() title: string;
  constructor(private el: ElementRef, private http: HttpClient) { }
  @HostListener('click') onClick() {
    this.http.post(this.url, this.payload).subscribe(res => {
      const url = window.URL.createObjectURL(res);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = this.title + '.xls';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    });
  }

}
